export const uniqueCharactersString = (str: string): string => {
  // Split the string to make an array
  const charArray = str.split('');

  // Create a set using the array (removes duplicates)
  const uniqueSet = new Set(charArray);

  // Convert the set into an array using spread operator and join it to make a string
  const uniqueStr = [...uniqueSet].join('');

  return uniqueStr;
};
